import { useEffect } from "react";
import axios from "axios";
import { getServiceUrl } from "service/api";

const HEARTBEAT_MS = 60 * 1000;
// Only counts as "active" if the user touched the page within this window.
const INTERACTION_WINDOW_MS = 60 * 1000;
const EVENTS = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel", "click"];

const getToken = () => {
  try {
    const raw = window.localStorage.getItem("user");
    return raw ? JSON.parse(raw)?.token || "" : "";
  } catch {
    return "";
  }
};

/**
 * Tells the backend the user is really using Talent Spotify (tab visible and
 * recent mouse / keyboard / scroll / touch). Server-side API traffic already
 * counts as activity; this covers reading a page with no API calls.
 *
 * Isolated axios instance + silent failures: it can never log the user out or
 * interfere with any other request.
 */
export default function SessionHeartbeat() {
  useEffect(() => {
    let lastInteraction = 0;
    const markInteraction = () => {
      lastInteraction = Date.now();
    };
    EVENTS.forEach((e) => window.addEventListener(e, markInteraction, { passive: true }));

    const client = axios.create({ timeout: 10000 });
    const tick = () => {
      if (document.visibilityState !== "visible") return;
      if (Date.now() - lastInteraction > INTERACTION_WINDOW_MS) return;
      const token = getToken();
      if (!token) return;
      client
        .post(
          `${getServiceUrl("production")}sessions/heartbeat`,
          { app: "talentspotify", state: "interaction", page: window.location.pathname },
          { headers: { Authorization: `Bearer ${token}`, "X-App": "talentspotify" } },
        )
        .catch(() => {});
    };
    const timer = setInterval(tick, HEARTBEAT_MS);

    return () => {
      clearInterval(timer);
      EVENTS.forEach((e) => window.removeEventListener(e, markInteraction));
    };
  }, []);

  return null;
}
